/**
 * Config and constants - must run first.
 * Attaches to window for use by non-module scripts (paramsStorageobj, templates).
 */

console.log("I am config.js");
const isLocalhost = window.location.href.includes("localhost");
const hostname = window.location.hostname.toLowerCase();
const isArxenaHost = hostname === "arxena.com" || hostname.endsWith(".arxena.com");
const productionBaseUrl = isArxenaHost
  ? window.location.origin
  : "https://arxena.com";
const base_url = isLocalhost
  ? "http://localhost:5050"
  : productionBaseUrl;

console.log("isLocalhost", isLocalhost);
console.log("isArxenaHost", isArxenaHost);
console.log("productionBaseUrl", productionBaseUrl);
console.log("base_url", base_url);
/** Twenty app (NestJS) – where users log in (e.g. app.localhost:3001/welcome) */
const app_base_url = isLocalhost
  ? "http://app.localhost:3001"
  : "https://app.arxena.com";

localStorage["base_url"] = base_url;

if (isArxenaHost) {
  console.log = function () {};
}

window.base_url = base_url;
window.app_base_url = app_base_url;
window.myDiagram = null;
window.delayTimer = null;
window.shift_key_pressed = false;
window.mobile = false;
window.load_type = null;
window.user_obj = null;
window.element_focussed = null;

export function goToChatBotNextJS() {
  window.location.href = app_base_url + "/";
}

export const eUrl = {
  gptProcess: base_url + "/gpt_process",
  dataPolling: base_url + "/cs2504",
  createNewJob: base_url + "/create_new_job",
  uploadProfile: base_url + "/upload_profiles",
  gptCost: base_url + "/gpt_token_cost_compute",
  chatBotConfig: base_url + "/add_chatbot_config",
};

export const eMethod = {
  get: "GET",
  post: "POST",
};

export const gpt_prompts = [
  { type: "defined", field: "Name", data: "full_name", prompt: "" },
  { type: "defined", field: "Education UG", data: "education_ug", prompt: "" },
  { type: "defined", field: "Education PG", data: "education_pg", prompt: "" },
  { type: "defined", field: "Education", data: "education", prompt: "" },
  { type: "defined", field: "Job Titles", data: "job_title", prompt: "" },
  { type: "defined", field: "Profile", data: "profile_title", prompt: "" },
  { type: "defined", field: "Location", data: "location_name", prompt: "" },
  { type: "defined", field: "Company Name", data: "job_company_name", prompt: "" },
  { type: "defined", field: "Experience", data: "experience", prompt: "" },
  { type: "defined", field: "Fitment Analytics", data: "fitment", prompt: "" },
  { type: "defined", field: "CV/Resume Analytics", data: "raw_cv", prompt: "" },
];

// Attach to window for global access
window.eUrl = eUrl;
window.eMethod = eMethod;
window.gpt_prompts = gpt_prompts;
window.goToChatBotNextJS = goToChatBotNextJS;
